module.exports = jschardet;